import {createSvgIcon} from '../create-svg-icon';

export const EdgesensorLowIcon = createSvgIcon(
  <path d="M2 7h2v7H2V7zm18 3h2v7h-2v-7zm-4-7.99L8 2c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V4c0-1.1-.9-1.99-2-1.99zM16 20H8v-1h8v1zm0-3H8V7h8v10zM8 5V4h8v1H8z" />
, 'EdgesensorLowOutlined');
